import { Link } from "@inertiajs/react";
import { HomeSectionLayout } from "../../../../../components/HomeSectionLayout";
import { FeaturedContentItem } from "../index";
import { BreadCrumbs } from "../../../../../components/BreadCrumbs";
import { SECTION_COLORS } from "../../../../../utils/colors";
import ReferenceCard from "./ReferenceCard";

interface ReferencesSectionItem extends FeaturedContentItem {
  title: string;
  description?: string;
  references: Array<{ id: number; title: string }>;
}

export default function ReferencesSectionSection({ item, index }: { item: FeaturedContentItem; index: number }) {
  const section = item as ReferencesSectionItem;
  const colors = SECTION_COLORS[index % SECTION_COLORS.length];

  return (
    <HomeSectionLayout.Container style={{
      backgroundColor: colors.bg,
      color: colors.text
    }}>
      <div style={{
        width: '100%'
      }}>
        <HomeSectionLayout.HeaderDescription>
          <BreadCrumbs.Container>
            <BreadCrumbs.LinkItem href="/reference">
              Reference
            </BreadCrumbs.LinkItem>
          </BreadCrumbs.Container>
        </HomeSectionLayout.HeaderDescription>
        <HomeSectionLayout.Header>{section.title}</HomeSectionLayout.Header>
      </div>
      <div>
        {section.text_preview}{' '}
        <Link
          href={`/references/${section.id}`}
          className="link link-primary"
        >
          read more
        </Link>
      </div>
      <HomeSectionLayout.Content>
        <div style={{
          gap: '20px',
          width: '100%',

          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 400px), 1fr))',
        }}>

          {section.references.map((ref) => (
            <div>
              <ReferenceCard
                key={`page-${ref.id}`}
                item={ref as any}
                sectionId={section.id}
              />
            </div>
          ))}
        </div>
      </HomeSectionLayout.Content>
    </HomeSectionLayout.Container>
  )
}
